export var formatUserDateWithWeekday = function (date, locale) {
    return new Intl.DateTimeFormat(locale, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
        .format(date)
        .replace(/ /g, '\xA0');
};
